
import { Typography } from '@mui/material';

export default function TileHeading({ title, id, asLabel = false, passedHtmlFor = "" }) {
  return (
    <Typography
      component={asLabel ? 'label' : 'h3'}
      id={id}
      variant="subtitle2"
      sx={{
        fontWeight: 'bold',
        padding: 2,
        display: 'block',

        ...(asLabel && {
          fontSize: '0.875rem',
        }),
      }}
      htmlFor={passedHtmlFor}
    >
      {title}
    </Typography>
  );
}
